import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { Select } from "Components/Form";

export const DateSelectorItemContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "334px",
  hight: "44px",
}));

export const DateSelectorLabel = styled("span")(() => ({
  color: colors.gray700,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: "0.1px",
}));

export const DateSelectorDescription = styled("span")(() => ({
  color: colors.gray500,
  fontFamily: "Manrope",
  fontSize: "10px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "15px",
  letterSpacing: "0.5px",
  textTransform: "uppercase",
}));

export const PeriodSelector = styled(Select)(() => ({
  width: "188px",
}));
